import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import { Save } from "lucide-react";

import API from "../../../../services/api";

import "./SaveButton.css";

function SaveButton({ profile }) {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const handleSave = async () => {

        try {

            setLoading(true);

            const response = await API.put(

                "/delivery/profile",

                profile

            );

            if (response.data.success) {

                alert("Profile updated successfully.");

                navigate("/delivery/profile");

            }

        }

        catch (error) {

            console.log(error);

            alert(

                error.response?.data?.message ||

                "Unable to update profile."

            );

        }

        finally {

            setLoading(false);

        }

    };

    return (

        <div className="save-button-container">

            <button

                className="save-profile-btn"

                onClick={handleSave}

                disabled={loading}

            >

                <Save size={20} />

                {

                    loading

                        ? "Saving..."

                        : "Save Changes"

                }

            </button>

        </div>

    );

}

export default SaveButton;